import SketchWrapper from "../../../../src/components/SketchWrapper";
import LoopSketchIntro from "../../../../content/posts/generative-animation-for-stroboscopic-discs/sketches/LoopSketchIntro.js";
import LoopSketchPastPresentFuture from "../../../../content/posts/generative-animation-for-stroboscopic-discs/sketches/LoopSketchPastPresentFuture.js";
import * as React from 'react';
export default {
  SketchWrapper,
  LoopSketchIntro,
  LoopSketchPastPresentFuture,
  React
};